import React, { useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import AuthService from 'service/AuthService';
import { loginSuccess } from 'action/AuthAction';

const Gate: React.FC = () => {
  const [searchParams] = useSearchParams();
  const sId = searchParams.get("sId");
  
  const { sessionId } = useSelector((state: any) => state.auth);

  const [error, setError] = React.useState<string>("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const authService = AuthService();

  // http://localhost:3000/?sId=RQKjozJiUh
  const decodeWebSession = async () => {
    if (sessionId === sId) {
      navigate('/contracts');
      return;
    }

    try {
      const res = await authService.decodeDashboardWeb(sId as string);
      dispatch(loginSuccess({ token: res.data.token, profile: res.data, session: sessionId }))
      navigate('/contracts');
    } catch (error) {
      console.error('Decode Error:', error);
      setError(error as string);
    }
  };

  useEffect(() => {
    console.log('Gate sessionId:', sId);
    if (sId) {
      decodeWebSession()
    } else {
      navigate('/contracts');
    }
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <p>{error}</p>
    </div>
  );
};

export default Gate;